import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../assets/animations/loading.json';
import { useLoading } from '../contexts/LoadingContext';

const GlobalLoader = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white bg-opacity-75 backdrop-blur-xs">
      <div className="w-[150px] h-[150px] sm:w-[200px] sm:h-[200px] md:w-[250px] md:h-[250px]">
        <Lottie
          animationData={loadingAnimation}
          loop={true}
          autoplay={true}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  );
};

export default GlobalLoader; 